export function dismissLoader() {
  const el = document.getElementById('app-loader');
  if (!el) return;
  if (el.classList.contains('show')) {
    el.classList.add('fade-out');
    setTimeout(() => el.remove(), 300);
  } else {
    el.remove();
  }
}
